import { render, staticRenderFns } from "./avatar_image.vue?vue&type=template&id=2d4a1208&"
import script from "./avatar_image.vue?vue&type=script&lang=js&"
export * from "./avatar_image.vue?vue&type=script&lang=js&"
import style0 from "./avatar_image.vue?vue&type=style&index=0&id=2d4a1208&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports